export default "__VITE_ASSET__MbfOJRqT__"